/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `ACCEPTED` - ACCEPTED
 *   * `CANCELED` - CANCELED
 *   * `CLOSED` - CLOSED
 *   * `CLOSED_FINAL` - CLOSED_FINAL
 *   * `CLOSE_CHECKS_FAILED` - CLOSE_CHECKS_FAILED
 *   * `CLOSE_FAILED` - CLOSE_FAILED
 *   * `CLOSE_FINAL_FAILED` - CLOSE_FINAL_FAILED
 *   * `CLOSE_INTERRUPTED` - CLOSE_INTERRUPTED
 *   * `CLOSING_READY_TO_SEND_TO_DMVS` - CLOSING_READY_TO_SEND_TO_DMVS
 *   * `CLOSING` - CLOSING
 *   * `CLOSING_FINAL` - CLOSING_FINAL
 *   * `DELEGATE_FAILED` - DELEGATE_FAILED
 *   * `DELEGATE_REJECTED` - DELEGATE_REJECTED
 *   * `DELEGATED` - DELEGATED
 *   * `DMVS_COMMUNICATION_FAILED` - DMVS_COMMUNICATION_FAILED
 *   * `DRAFT` - DRAFT
 *   * `DRAFT_CHECKED` - DRAFT_CHECKED
 *   * `EDIT_REJECTED` - EDIT_REJECTED
 *   * `EDIT_SUPERVISING` - EDIT_SUPERVISING
 *   * `EDIT_TAKEOVER_REJECTED` - EDIT_TAKEOVER_REJECTED
 *   * `EDITING` - EDITING
 *   * `FAILED_TO_GET_SYNCHRONIZE_DATA` - FAILED_TO_GET_SYNCHRONIZE_DATA
 *   * `FAILED_TO_SEND_SYNCHRONIZE_DATA` - FAILED_TO_SEND_SYNCHRONIZE_DATA
 *   * `IMPORT_FAILED` - IMPORT_FAILED
 *   * `IMPORT_INTERRUPTED` - IMPORT_INTERRUPTED
 *   * `IMPORTED` - IMPORTED
 *   * `IMPORTED_WITH_ERRORS` - IMPORTED_WITH_ERRORS
 *   * `IMPORTING` - IMPORTING
 *   * `INPROGRESS` - INPROGRESS
 *   * `NOTIFYING_CLOSED` - NOTIFYING_CLOSED
 *   * `NOTIFYING_CLOSE` - NOTIFYING_CLOSE
 *   * `NOTIFYING_CLOSE_FAILED` - NOTIFYING_CLOSE_FAILED
 *   * `PREPARING_FOR_EDIT` - PREPARING_FOR_EDIT
 *   * `PREPARING_FOR_EDIT_WITH_ERRORS` - PREPARING_FOR_EDIT_WITH_ERRORS
 *   * `PROCESS_FAILED` - PROCESS_FAILED
 *   * `PROCESSED` - PROCESSED
 *   * `PROCESSED_SENT_TO_COUNTERPART` - PROCESSED_SENT_TO_COUNTERPART
 *   * `PROCESSING` - PROCESSING
 *   * `READY_TO_IMPORT` - READY_TO_IMPORT
 *   * `READY_TO_PROCESS` - READY_TO_PROCESS
 *   * `READY_TO_SEND_TO_DMVS` - READY_TO_SEND_TO_DMVS
 *   * `READY_TO_SYNCHRONIZE` - READY_TO_SYNCHRONIZE
 *   * `READY_TO_CHECK_SVU_CROSS_KRAJ` - READY_TO_CHECK_SVU_CROSS_KRAJ
 *   * `WAITING_FOR_CHECK_SVU_CROSS_KRAJ` - WAITING_FOR_CHECK_SVU_CROSS_KRAJ
 *   * `CHECKING_SVU_CROSS_KRAJ` - CHECKING_SVU_CROSS_KRAJ
 *   * `CHECK_SVU_CROSS_KRAJ_FAILED` - CHECK_SVU_CROSS_KRAJ_FAILED
 *   * `REJECTED` - REJECTED
 *   * `REJECTED_BY_COUNTERPART` - REJECTED_BY_COUNTERPART
 *   * `SEND_TO_DMVS_FAILED` - SEND_TO_DMVS_FAILED
 *   * `SEND_TO_COUNTERPART_FAILED` - SEND_TO_COUNTERPART_FAILED
 *   * `SENDING_TO_DMVS` - SENDING_TO_DMVS
 *   * `SENDING_TO_COUNTERPART` - SENDING_TO_COUNTERPART
 *   * `SENT_TO_COUNTERPART` - SENT_TO_COUNTERPART
 *   * `SENT_TO_DMVS` - SENT_TO_DMVS
 *   * `SIGNING` - SIGNING
 *   * `SIGNED_FAILED` - SIGNED_FAILED
 *   * `SIGNED` - SIGNED
 *   * `SUBMITTED` - SUBMITTED
 *   * `SYNCHRONIZED` - SYNCHRONIZED
 *   * `SYNCHRONIZE_FAILED` - SYNCHRONIZE_FAILED
 *   * `SYNCHRONIZING` - SYNCHRONIZING
 *   * `TAKEN_OVER` - TAKEN_OVER
 *   * `WAITING_FOR_CLOSE` - WAITING_FOR_CLOSE
 *   * `WAITING_FOR_CLOSE_FINAL` - WAITING_FOR_CLOSE_FINAL
 *   * `WAITING_FOR_IMPORT` - WAITING_FOR_IMPORT
 *   * `WAITING_FOR_REJECT` - WAITING_FOR_REJECT
 *   * `WAITING_FOR_REJECT_FAILED` - WAITING_FOR_REJECT_FAILED
 *   * `WAITING_FOR_PROCESS` - WAITING_FOR_PROCESS
 *   * `WAITING_FOR_SYNCHRONIZE` - WAITING_FOR_SYNCHRONIZE
 *   * `WAITING_FOR_SYNCHRONIZE_DATA` - WAITING_FOR_SYNCHRONIZE_DATA
 * ```
 */
export const DocStatesEnum = {
  ACCEPTED: 'ACCEPTED',
  CANCELED: 'CANCELED',
  CLOSED: 'CLOSED',
  CLOSED_FINAL: 'CLOSED_FINAL',
  CLOSE_CHECKS_FAILED: 'CLOSE_CHECKS_FAILED',
  CLOSE_FAILED: 'CLOSE_FAILED',
  CLOSE_FINAL_FAILED: 'CLOSE_FINAL_FAILED',
  CLOSE_INTERRUPTED: 'CLOSE_INTERRUPTED',
  CLOSING_READY_TO_SEND_TO_DMVS: 'CLOSING_READY_TO_SEND_TO_DMVS',
  CLOSING: 'CLOSING',
  CLOSING_FINAL: 'CLOSING_FINAL',
  DELEGATE_FAILED: 'DELEGATE_FAILED',
  DELEGATE_REJECTED: 'DELEGATE_REJECTED',
  DELEGATED: 'DELEGATED',
  DMVS_COMMUNICATION_FAILED: 'DMVS_COMMUNICATION_FAILED',
  DRAFT: 'DRAFT',
  DRAFT_CHECKED: 'DRAFT_CHECKED',
  EDIT_REJECTED: 'EDIT_REJECTED',
  EDIT_SUPERVISING: 'EDIT_SUPERVISING',
  EDIT_TAKEOVER_REJECTED: 'EDIT_TAKEOVER_REJECTED',
  EDITING: 'EDITING',
  FAILED_TO_GET_SYNCHRONIZE_DATA: 'FAILED_TO_GET_SYNCHRONIZE_DATA',
  FAILED_TO_SEND_SYNCHRONIZE_DATA: 'FAILED_TO_SEND_SYNCHRONIZE_DATA',
  IMPORT_FAILED: 'IMPORT_FAILED',
  IMPORT_INTERRUPTED: 'IMPORT_INTERRUPTED',
  IMPORTED: 'IMPORTED',
  IMPORTED_WITH_ERRORS: 'IMPORTED_WITH_ERRORS',
  IMPORTING: 'IMPORTING',
  INPROGRESS: 'INPROGRESS',
  NOTIFYING_CLOSED: 'NOTIFYING_CLOSED',
  NOTIFYING_CLOSE: 'NOTIFYING_CLOSE',
  NOTIFYING_CLOSE_FAILED: 'NOTIFYING_CLOSE_FAILED',
  PREPARING_FOR_EDIT: 'PREPARING_FOR_EDIT',
  PREPARING_FOR_EDIT_WITH_ERRORS: 'PREPARING_FOR_EDIT_WITH_ERRORS',
  PROCESS_FAILED: 'PROCESS_FAILED',
  PROCESSED: 'PROCESSED',
  PROCESSED_SENT_TO_COUNTERPART: 'PROCESSED_SENT_TO_COUNTERPART',
  PROCESSING: 'PROCESSING',
  READY_TO_IMPORT: 'READY_TO_IMPORT',
  READY_TO_PROCESS: 'READY_TO_PROCESS',
  READY_TO_SEND_TO_DMVS: 'READY_TO_SEND_TO_DMVS',
  READY_TO_SYNCHRONIZE: 'READY_TO_SYNCHRONIZE',
  READY_TO_CHECK_SVU_CROSS_KRAJ: 'READY_TO_CHECK_SVU_CROSS_KRAJ',
  WAITING_FOR_CHECK_SVU_CROSS_KRAJ: 'WAITING_FOR_CHECK_SVU_CROSS_KRAJ',
  CHECKING_SVU_CROSS_KRAJ: 'CHECKING_SVU_CROSS_KRAJ',
  CHECK_SVU_CROSS_KRAJ_FAILED: 'CHECK_SVU_CROSS_KRAJ_FAILED',
  REJECTED: 'REJECTED',
  REJECTED_BY_COUNTERPART: 'REJECTED_BY_COUNTERPART',
  SEND_TO_DMVS_FAILED: 'SEND_TO_DMVS_FAILED',
  SEND_TO_COUNTERPART_FAILED: 'SEND_TO_COUNTERPART_FAILED',
  SENDING_TO_DMVS: 'SENDING_TO_DMVS',
  SENDING_TO_COUNTERPART: 'SENDING_TO_COUNTERPART',
  SENT_TO_COUNTERPART: 'SENT_TO_COUNTERPART',
  SENT_TO_DMVS: 'SENT_TO_DMVS',
  SIGNING: 'SIGNING',
  SIGNED_FAILED: 'SIGNED_FAILED',
  SIGNED: 'SIGNED',
  SUBMITTED: 'SUBMITTED',
  SYNCHRONIZED: 'SYNCHRONIZED',
  SYNCHRONIZE_FAILED: 'SYNCHRONIZE_FAILED',
  SYNCHRONIZING: 'SYNCHRONIZING',
  TAKEN_OVER: 'TAKEN_OVER',
  WAITING_FOR_CLOSE: 'WAITING_FOR_CLOSE',
  WAITING_FOR_CLOSE_FINAL: 'WAITING_FOR_CLOSE_FINAL',
  WAITING_FOR_IMPORT: 'WAITING_FOR_IMPORT',
  WAITING_FOR_REJECT: 'WAITING_FOR_REJECT',
  WAITING_FOR_REJECT_FAILED: 'WAITING_FOR_REJECT_FAILED',
  WAITING_FOR_PROCESS: 'WAITING_FOR_PROCESS',
  WAITING_FOR_SYNCHRONIZE: 'WAITING_FOR_SYNCHRONIZE',
  WAITING_FOR_SYNCHRONIZE_DATA: 'WAITING_FOR_SYNCHRONIZE_DATA',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DocStatesEnum = ValuesOf<typeof DocStatesEnum>;

export type DocStatesEnumRequest = DocStatesEnum;
export type DocStatesEnumResponse = DocStatesEnum;
